import { ModelBase, observable } from "@shoothill/core";
import { action } from "mobx";
import { DailyProgrammeProgressUpdateV2ItemModel, DailyProgrammeProgressUpdateV2ItemDTO } from "./DailyProgrammeProgressUpdateV2ItemModel";

export class DailyProgrammeProgressUpdateV2Model extends ModelBase<DailyProgrammeProgressUpdateV2Model> {
    @observable id: string | null = null;
    @observable projectId: string | null = null;
    @observable createdDate: string | null = null;
    @observable createdByUserId: string | null = null;
    @observable lastUpdatedDate: string | null = null;
    @observable lastUpdatedByUserId: string | null = null;
    @observable rowVersion: string | null = null;
    @observable items: DailyProgrammeProgressUpdateV2ItemModel[] = [];

    @action
    fromDto(dto: DailyProgrammeProgressUpdateV2DTO) {
        if (dto) {
            this.id = dto.id;
            this.projectId = dto.projectId;
            this.createdDate = dto.createdDate;
            this.createdByUserId = dto.createdByUserId;
            this.lastUpdatedDate = dto.lastUpdatedDate;
            this.lastUpdatedByUserId = dto.lastUpdatedByUserId;
            this.rowVersion = dto.rowVersion;
            this.items = (dto.items || []).map((item) => {
                const model = new DailyProgrammeProgressUpdateV2ItemModel();
                model.fromDto(item);
                return model;
            });
        }
    }

    toDto(): DailyProgrammeProgressUpdateV2DTO {
        return {
            id: this.id,
            projectId: this.projectId,
            createdDate: this.createdDate,
            createdByUserId: this.createdByUserId,
            lastUpdatedDate: this.lastUpdatedDate,
            lastUpdatedByUserId: this.lastUpdatedByUserId,
            rowVersion: this.rowVersion,
            items: this.items.map((item) => item.toDto()),
        };
    }

    @action
    reset() {
        this.id = null;
        this.projectId = null;
        this.createdDate = null;
        this.createdByUserId = null;
        this.lastUpdatedDate = null;
        this.lastUpdatedByUserId = null;
        this.rowVersion = null;
        this.items = [];
    }
}

export interface DailyProgrammeProgressUpdateV2DTO {
    id: string | null;
    projectId: string | null;
    createdDate: string | null;
    createdByUserId: string | null;
    lastUpdatedDate: string | null;
    lastUpdatedByUserId: string | null;
    rowVersion: string | null;
    items: DailyProgrammeProgressUpdateV2ItemDTO[];
}

export interface UpsertDailyProgrammeProgressUpdateV2RequestDTO {
    dailyProgrammeProgressUpdateV2: DailyProgrammeProgressUpdateV2DTO;
    dailyProgrammeProgressUpdateV2Items: DailyProgrammeProgressUpdateV2ItemDTO[];
}

export interface UpsertDailyProgrammeProgressUpdateV2ResponseDTO {
    dailyProgrammeProgressUpdateV2: DailyProgrammeProgressUpdateV2DTO;
    dailyProgrammeProgressUpdateV2Items: DailyProgrammeProgressUpdateV2ItemDTO[];
}

export interface DailyProgrammeProgressUpdateV2ByIdResponseDTO {
    dailyProgrammeProgressUpdateV2: DailyProgrammeProgressUpdateV2DTO;
    dailyProgrammeProgressUpdateV2Items: DailyProgrammeProgressUpdateV2ItemDTO[];
}
